module.exports = __webpack_public_path__ + "img/lbp-illustration.384dda70.png";